'use client';

import { Banner } from '@flipster/apis/v1/banner/types';
import { BaseFaqItemFragment } from '@flipster/features/src/contentful/faq/query.generated';
import { EarnSunsetModalHost } from '@flipster/features/src/flipster-earn/sunset/sunset-modal/host';
import { useCheckSpotOnly } from '@flipster/features/src/shared/regulation';
import { useMounted } from '@flipster/react/misc/lifecycle/mount';

import Main from './BaseMain';
import SpotMain from './SpotMain';

interface Props {
  heroCarousel?: Banner[];
  promotions?: Banner[];
  faqs?: BaseFaqItemFragment[];
  varaFaqs?: BaseFaqItemFragment[];
}

const MainPage = (props: Props) => {
  const isMounted = useMounted();
  const isSpotOnly = useCheckSpotOnly();

  if (isSpotOnly && isMounted) return <SpotMain faqs={props.varaFaqs} />;
  return (
    <>
      <EarnSunsetModalHost />
      <Main {...props} />
    </>
  );
};

export default MainPage;
